// extracted by mini-css-extract-plugin
export var button = "CookiesBanner-module--button--e8dd1";
export var buttonsWrapper = "CookiesBanner-module--buttonsWrapper--e2813";
export var closeButton = "CookiesBanner-module--closeButton--c58b2";
export var container = "CookiesBanner-module--container--5b02b";
export var disabled = "CookiesBanner-module--disabled--126b2";
export var hidden = "CookiesBanner-module--hidden--9b3c1";
export var innerContainer = "CookiesBanner-module--innerContainer--735b0";
export var visuallyHidden = "CookiesBanner-module--visuallyHidden--41525";